import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 48rem;
    margin: 5rem auto;
    min-height: 100vh;
    padding: 1rem;
    ${device.md} {
        padding: 1rem 2rem;
    }
`;

export const Time = styled.time`
    display: block;
    margin-bottom: 0.5rem;
    color: ${colourScheme.grey};
`;

export const DescriptionContainer = styled.div`
    border-bottom: 1px solid ${colourScheme.grey};
`;

export const BackLink = styled.div`
    margin-bottom: 1rem;

    a {
        color: ${colourScheme.success};
        text-decoration: none;
        font-weight: bold;
        &:hover {
            text-decoration: underline;
        }
    }
`;
